<ng-template #namedResultTemplate let-r="result" let-t="term">
  <ngb-highlight
    [result]="((attributeType === 'POOL' || attributeType === 'LOCATION' || attributeType === 'CHANNEL') ? r.name : r)"
    [term]="t"></ngb-highlight>
</ng-template>
<ng-template #resultTemplate let-r="result" let-t="term">
  <ngb-highlight [ngStyle]="{'font-style': r ==='' || r === t ? 'italic' : 'none'}"
                 [result]="r ? r : ('lang.globals.empty'| translate)"
                 [term]="t"></ngb-highlight>
</ng-template>
<div class="modal-header">
  <h5 class="modal-title">{{ options.title }} </h5>
</div>
<div class="modal-body">
  <fieldset class="form-inline">
    <div class="d-flex dropdownDeep">
      <button class="btn btn-default" type="button" container="body"
              [ngbTooltip]="'lang.globals.search'|translate" (click)="openSuggestions()">
        <sb-icon class="icon-in-btn" icon="search"></sb-icon>
      </button>
      <ng-container
        *ngIf="attributeType === 'POOL' || attributeType === 'LOCATION' || attributeType === 'CHANNEL' || cullAtomAutocomplete; else searchElse">
        <input type="text"
               class="form-control mx-sm-3"
               #inputElementIf
               [class.is-invalid]="searchFailed"
               [(ngModel)]="selectedOption"
               [ngbTypeahead]="dosearch"
               placeholder="..."
               [resultTemplate]="namedResultTemplate"
               [inputFormatter]="namedFormatter"
               [editable]='false'
               (keyup.enter)="enterpress()"
               [disabled]="empty"
        />
      </ng-container>
      <ng-template #searchElse>
        <input type="text"
               #inputElementElse
               class="form-control mx-sm-3"
               [class.is-invalid]="searchFailed"
               [(ngModel)]="selectedOption"
               [ngbTypeahead]="dosearch"
               [resultTemplate]="resultTemplate"
               placeholder="..."
               (keyup.enter)="enterpress()"
               [disabled]="empty"
        />
      </ng-template>
      <sb-icon class="cursor-pointer red mr-3" *ngIf="checkShowDelete()" [icon]="'trash'" (click)="clear()"></sb-icon>
      <div class="form-check form-switch mr-3 offline">
        <input type="checkbox" role="switch" class="form-check-input" id="swEmpty" [(ngModel)]="empty">
        <label class="form-check-label" for="swEmpty">{{'lang.globals.emptyValue'| translate}}</label>
      </div>
      <small *ngIf="searching" class="form-text text-muted">{{'lang.globals.searching'|translate}}</small>
      <div class="invalid-feedback" *ngIf="searchFailed">{{'lang.globals.searching'|translate}}</div>
    </div>
    <div>&nbsp;</div>
    <div style="margin-left: 14px;">{{'lang.globals.selectedValue'|translate}}:&nbsp;
      {{getSelectedOptionText()}}
    </div>
  </fieldset>
</div>
<div class="modal-footer">
  <sb-button classes="btn-primary" (click)="ok()" [disabled]="!checkOkEnabled()">{{ 'lang.globals.ok' | translate }}
  </sb-button>
  <sb-button classes="btn-default" (click)="cancel()">{{ 'lang.globals.cancel' | translate }}
  </sb-button>
</div>
